import Vue from "vue";
import VueRouter from "vue-router";

import Experience from "../views/DetailedExperience.vue";
import Market from "../views/Market.vue";
import notFound from "../views/notFound.vue";
import Home from "../views/Mixer.vue";
import projectsAll from "../views/projectsAll.vue";
import SkillDetails from "../views/Skillset.vue";
import Contact from "../components/Contact.vue";
import projectsOne from "../views/projectsOne.vue";
import moreAbout from "../views/moreAbout.vue";
import pricing from "../views/Pricing.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/experience",
    name: "Experience",
    component: Experience
  },
  {
    path: "/market",
    name: "Market",
    component: Market
  },
  {
    path: "/projects",
    name: "Projects",
    component: projectsAll
  },
  {
    path: "/skillset/:query",
    name: "Skills",
    component: SkillDetails
  },
  {
    path: "/projects/:query",
    name: "Project",
    component: projectsOne
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  },
  {
    path: "/about",
    name: "About",
    component: moreAbout
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: pricing
  },
  {
    path: "/pricing/:invoice",
    name: "seekInvoice",
    component: pricing
  },
  {
    path: "*",
    name: "notFound",
    component: notFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  setTimeout(() => window.scrollTo({top: 0, behavior: 'smooth'}), 500);
  next();
});

export default router;
